module.exports = __webpack_public_path__ + "img/ICONO10.6def4a8e.png";